import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgahLogo1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={33} height={33} fill='none' {...props}>
    <g clipPath='url(#agah-logo-1_svg__a)'>
      <path
        fill='currentColor'
        d='M32.333 16.326h-6.362c-.005-5.318-4.323-9.625-9.64-9.625a9.5 9.5 0 0 0-3.805.785 9.6 9.6 0 0 0-3.895 3.06 9.6 9.6 0 0 0-1.936 5.78v.017a9.634 9.634 0 0 0 9.635 9.635 9.6 9.6 0 0 0 3.793-.773l2.512 5.848a16 16 0 0 1-6.305 1.293C7.496 32.34.333 25.176.333 16.343v-.017a15.95 15.95 0 0 1 3.212-9.608 16 16 0 0 1 6.469-5.08A15.9 15.9 0 0 1 16.33.34c8.834 0 15.997 7.157 16.003 15.986'
      />
      <path fill='var(--blue-1-active)' d='M25.972 16.326v.017c0 3.974-2.41 7.39-5.843 8.862l-3.81-8.879z' />
    </g>
    <defs>
      <clipPath id='agah-logo-1_svg__a'>
        <path fill='#fff' d='M.333.5h32v32h-32z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAgahLogo1;
